const PaymentMethodRef = require('@/lib/PaymentMethods/PaymentMethodRef');
const VerifoneIntegrationType = require('@/lib/PaymentMethods/Verifone/VerifoneIntegrationType');

class VerifoneAuthHandler {
    /**
     * @param $injector
     * @param {PaymentMethodService} paymentMethodService
     */
    constructor(
        $injector,
        paymentMethodService
    ) {
        /**
         * @private
         */
        this.$injector = $injector;

        /**
         * @private
         * @type {PaymentMethodService}
         */
        this.paymentMethodService = paymentMethodService;
    }

    /**
     * @private
     * @return {VerifoneDriver}
     */
    getDriver() {
        return this.$injector.get('verifoneDriver');
    }

    /**
     * @private
     * @return {?PaymentMethod}
     */
    getPaymentMethod() {
        return this.paymentMethodService.getByRef(PaymentMethodRef.CARD_VERIFONE_CHIP_AND_PIN);
    }

    /**
     * @return {boolean}
     */
    verifoneIsEnabled() {
        return !!this.getPaymentMethod();
    }

    login() {
        if (this.verifoneIsEnabled()) {
            const driver = this.getDriver();

            // If the company has the Verifone payment method, and there is a userId and userPin, login to
            // the terminal now.
            if (driver.config.hasLoginCredentials()) {
                driver.login();
            }
        }
    }

    /**
     * @returns {Promise}
     */
    logout() {
        if (!this.verifoneIsEnabled()) {
            return Promise.resolve();
        }

        const driver = this.getDriver();

        // Cancel any transaction in progress.
        driver.cancelTransaction();

        if (driver.state.loggedIn !== false) {
            if (driver.config.integrationType === VerifoneIntegrationType.ENGAGE) {
                // Submit offline transactions on logout.
                return driver.submitOfflineTransactions()
                    .catch(() => {
                        // Suppress errors with submitting offline txns.
                    })
                    .then(() => driver.logout().catch(() => {}));
            }

            return driver.logout().catch(() => {});
        }

        return Promise.resolve();
    }
}

module.exports = VerifoneAuthHandler;
